import React from 'react';
import { Box, Container, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const boxBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Box bg={bgColor} minH='100vh' py={12}>
      <Container maxW='lg'>
        <VStack spacing={8}>
          <VStack spacing={2} textAlign='center'>
            <Heading fontSize='4xl'>Welcome Back</Heading>
            <Text fontSize='lg' color='gray.600'>
              Sign in to continue to dwelz
            </Text>
          </VStack>

          <Box w='100%' bg={boxBgColor} borderRadius='lg' p={8} boxShadow='lg'>
            <LoginForm />
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default Login;
